import { ElMessage } from "element-plus";
import { Ref, ref, watch } from "vue";

export function useHakuSelection(selectedNodes : Ref<[number, number, number][]>) {
    const model = ref<[number, number, number] | undefined>(undefined)

    const hakuSelectionChange = (value : [number, number, number]) => {
        if(selectedNodes.value.find(s => s[2] === value[2])) {
            ElMessage.info("Nimike on jo valittu")
        } else { 
            ElMessage.success("Nimike valittu")

            selectedNodes.value = [...selectedNodes.value, value]
        }

        setTimeout(() => {
            model.value = undefined
        }, 2000)
    }

    watch(model, (value) => {
        if(value?.length === 3) {
            hakuSelectionChange(value)
        }
    })

    return {
        model
    }
}